export const environment = {
    SELF_URL: window['environments']['SELF_URL'] || 'https://alpha.neutrinos-apps.com/admin',
    ALPHA_UI_ADMIN_SERVICE_URL:
        window['environments']['ALPHA_UI_ADMIN_SERVICE_URL'] || 'https://alpha.neutrinos-apps.com/adminservice',
    ALPHA_UI_DELTA_SERVICE_URL:
        window['environments']['ALPHA_UI_DELTA_SERVICE_URL'] || 'https://alpha.neutrinos-apps.com/versionservice',
    ALPHA_SERVICES:
        window['environments']['ALPHA_SERVICES'] || '["ALPHA_CONFIG_URL", "ALPHA_CASE_URL", "ALPHA_MODULES_URL"]',
    ENABLE_DASHBOARD_MENU: window['environments']['ENABLE_DASHBOARD_MENU'] || 'true',
    SKIP_ALPHA_AUTH: window['environments']['SKIP_ALPHA_AUTH'] || 'false',
    ALPHA_UI_MAKE_REQUEST_URL:
        window['environments']['ALPHA_UI_MAKE_REQUEST_URL'] || 'https://alpha.neutrinos-apps.com/version/',
    PLUGIN_TIMEOUT_MS: window['environments']['PLUGIN_TIMEOUT_MS'] || '10000',
    CACHE_TTL: window['environments']['CACHE_TTL'] || '5',
    ENABLE_IDLE_SESSION_TIMEOUT: window['environments']['ENABLE_IDLE_SESSION_TIMEOUT'] || 'true',
    ALPHA_UI_CONFIG_SERVICE_URL:
        window['environments']['ALPHA_UI_CONFIG_SERVICE_URL'] || 'http://localhost:3001/configservice',
    ALPHA_UI_MODULE_SERVICE_URL:
        window['environments']['ALPHA_UI_MODULE_SERVICE_URL'] || 'http://localhost:3003/modulesservice',
    FEATURE_FLAGS:
        window['environments']['FEATURE_FLAGS'] ||
        '["PULL_TASK", "ADMIN_FILTERS", "GLOBAL_CUSTOM_CODE", "CHANGE_TRACKING"]',
    DEV_MODE: window['environments']['DEV_MODE'] || 'true',
};
